import gql from 'graphql-tag';

export const UpdateUserAside = gql`
	mutation UpdateUser($input: UpdateUserInput!) {
		updateUser(input: $input) {
			id
			role
			isScopedUser
			admin
			companyId
			company {
				id
				accountType
				allowInternalMobility
				allowSelfReferrals
				allowSelfReferralsInternalLink
				analyticsCardInputValues
				API {
					googleClientId
					microsoftClientId
				}
				applyInternallyColor
				appStoreUrls {
					ios
					android
				}
				atsIntegration
				ATSProcessingConfig
				automationSettings
				background {
					bucket
					region
					key
				}
				bonusEarnedNote
				bonusReportFrequency
				bonusReportSetting
				brandColor
				companyInvitedId
				confirmCompliance
				confirmContactEmails
				contactIncentiveBonus
				countryCode
				customGeneralModal
				customText
				dashboardReferralPolicyText
				dashboardSearchBG {
					bucket
					region
					key
				}
				dateCreated
				defaultBonusAmount
				defaultLocation
				defaultToSubcompany
				departments {
					active
					companyId
					id
					name
					keywords
				}
				disableClaimYourAccountLogin
				disableExtendedUserJobsView
				disableManagerPermissions
				disableManagerPermissionsByType
				disableNewReferralSMSNotification
				disableReferrals
				disableSAMLLogin
				disableShareLink
				disableSite
				disableSmartReferrals
				eligibiltyChecks
				emailSettings
				employeeDashboard
				employeeDashboardRows
				employeeReportFrequency
				enableAcceptedReferralReminder
				enableAppReview
				enableCandidateBonus
				enableCareerProfile
				enableCustomDashboard
				enableCustomNav
				customNav
				customDashboard
				enableDashboardSearch
				enableExtendedNetwork
				enableGeneralReferrals
				enableGenericReferralEmail
				enableJobMatching
				enableJobNotifications
				enableLead
				enableProspectCreation
				enableRecognition
				enableReferralNetworkShare
				enableRetroactiveBonuses
				errorImage {
					bucket
					region
					key
				}
				externalUserSignUp
				favicon {
					bucket
					region
					key
				}
				faviconTitle
				generalReferralColor
				gifIds
				giftCardStoreAPIKeys {
					apiKey
					region
				}
				giftCardStoreBalance
				giftCardStorePendingBalance
				groupReportRecipients
				helpUrl
				hideBonus
				hideBonusFilterOnBrowseJobs
				hideCopyReferral
				hideDashboardSearch
				hideDateCreatedJobDetails
				hideInterestedForGroup
				hideJobsPage
				hideLoginForm
				hideMessageRecruiter
				hidePaymentInfoJobCard
				hidePaymentInfoReferralCard
				hideRecognitionLeaderboard
				hideRecognitionSocialShare
				hideRecruiterInfo
				hideRecruiterInfoJobDetails
				hideReferralsRanking
				hideShareLinkForDepartment
				hideShareLinkNoPublicUrl
				hideSubcompanyOnAcceptancePage
				hideSubcompanyOnJobs
				hideSubcompanyOnSignup
				hideWhatsApp
				host
				ignoreSubcompany
				includeAdminInRanking
				internalMobilityCustomTitle
				internalMobilityImage {
					bucket
					region
					key
				}
				isOptoutReferralUpdates
				jobFilterSettings
				jobNotificationFrequency
				jobNotificationSetting
				labelDepartment
				labelEmployeeID
				labelSocialShare
				linkName
				linkUrl
				loginFormPickerSettings
				loginFormSettings
				logo {
					bucket
					region
					key
				}
				maxJobsToShow
				metabaseReports {
					id
					label
					reportId
					reportType
				}
				name
				onboarding
				otherAPIKey
				ownershipSettings
				partnerBillingPolicy
				partnerClientId
				partnerHostId
				payBonusesWithPoints
				platformConfig
				pointsSettings
				popupTitle
				popupTitleContent
				preStartEnabled
				preStartUserGroupId
				privacyUrl
				publicLeaderboard
				recognitionCustomTitle
				recognitionEmailText
				recognitionSettings {
					allowRecognitionsForAccountClaims
					allowSelfNominations
					recognitionAnnouncementText
					recognitionCategories
					recognitionCustomTitle
					recognitionHashtags
					requireBadgeSelection
					requireBadgeAssignmentMessage
					customModal {
						title
						content
						isEnabled
						showEachLogin
					}
					hideRecognitionSocialShare
					hideRecognitionLeaderboard
					hideAllRecognitionsManager
					catalogOnlyGroupedByCategory
					customSendRecognitionBoxText
					customSendToPeerText
					disableRecHub
					disableNominations
					disableReplies
					disableReplyNotifications
					displayPointsAsCurrency
					recognitionPointsCurrency
					notificationOnApprovalDecision
					allowAdminBalanceOverrides
					rewardsEarnedMechanism
					baseSnappyBudget
					nominatedRecognitionsCostPoints
					enableManagerSendForm
					requireJustification
					requireAdminApproval
					assignSnappyRewardToRecognition
					tieredRewardsCampaign {
						id
						name
						description
						snappyGrantId
						snappyGrant {
							id
							externalSnappyId
							snappyCampaignId
							name
							description
							costInCurrency
						}
						unlockConditionType
						unlockConditionAmount
					}
					milestoneColorMap {
						years
						color
					}
					milestoneClaimExpiryDays
					milestoneClaimModalTitle
					milestoneClaimModalMessage
				}
				referralBonusNotificationRecipients
				referralBonusWaitingPeriod
				referralCustomStatuses
				referralLeadColor
				referralLeadsAllowDuplicateContacts
				referralNetworkShareOptions
				referralQuestions {
					id
					active
					companyId
					isCandidate
					questions
					sortOrder
					isInterested
					isGeneral
					subCompanyId
				}
				referralReportFrequency
				referralsReportDateRange
				referralsReportFrequency
				referralStatus
				referredReportTo
				requireBadgeSelection
				requireBonusChangeReason
				resetPopup
				selectedAdmins
				sendAdminNotificationsOnInternalCandidatesFound
				sendAdminNotificationsOnReferral
				senderEmailAddress
				sendNewJobsToAccountClaims
				sendReferralColor
				sftpFolderName
				SFTPProcessingConfig
				shareLogo {
					bucket
					region
					key
				}
				showPoweredByErin
				showRecruiterInfoJobCard
				socialImage {
					bucket
					region
					key
				}
				ssoGoogleDomain
				stages
				subCompanies {
					companyId
					id
					name
					keywords
				}
				subCompanyLabel
				symbol {
					bucket
					region
					key
				}
				termsUrl
				theme
				useJobSubcompanyinReferralEmail
				userEditSettings
				userGroups {
					companyId
					id
					name
					keywords
				}
				userSignupSettings
				websiteUrl
				whiteLabel
				whiteLabelServiceName
				whiteLabelSettings
			}
			departmentId
			department {
				id
				name
				companyId
			}
			subCompanyId
			subCompany {
				id
				name
				companyId
				logo {
					bucket
					region
					key
				}
			}
			userGroupId
			userGroup {
				id
				name
				companyId
			}
		}
	}
`;
